import { Box, Button, Flex } from '@chakra-ui/react'
import { organizationListContext } from 'brokertslib/src/context'
import { OrganizationUnitPagedQuery } from 'BrokerTsLib/src/dtos'
import { useGetAll } from 'BrokerTsLib/src/hooks/useOrganizationUnit'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { Add } from '../../icons'
import { PageToolbar } from '../PageToolbar'
import { SectionHeading } from '../shared/SectionHeading'
import { ValidityBadge } from '../shared/ValidityBadge'
import {
  OrganizationListCityColumn,
  OrganizationListDescriptionColumn,
  OrganizationListNameColumn,
  OrganizationListTypeColumn,
  OrganizationListValidColumn,
  OrganizationsList,
} from './OrganizationList'
import { OrganizationListFilter } from './OrganizationListFilter'

const pageSize = 15
export const DependentOrganizationUnitList = ({
  organizationUnitId,
  effectivalyValid,
}: {
  organizationUnitId: number
  effectivalyValid: boolean
}) => {
  const navigate = useNavigate()
  const [filter, setFilter] = useState<OrganizationUnitPagedQuery>({
    showInvalid: !effectivalyValid,
    showRootOnly: false,
    pageIndex: 1,
    pageSize,
    superiorOrganizationUnitId: organizationUnitId,
    showAllItems: true,
  })

  const { data, mutateAsync: getAll, isLoading } = useGetAll()

  useEffect(() => {
    setFilter((value) => ({
      ...value,
      superiorOrganizationUnitId: organizationUnitId,
    }))
  }, [organizationUnitId])

  useEffect(() => {
    getAll(filter)
  }, [filter, getAll])

  useEffect(() => {
    setFilter((value) => ({
      ...value,
      showInvalid: !effectivalyValid,
    }))
  }, [effectivalyValid])

  return (
    filter && (
      <Box sx={{ display: 'grid', gap: 4 }}>
        <organizationListContext.Provider
          value={{
            loading: isLoading,
            totalCount: data?.data.totalCount ?? 0,
            currentPage: 1,
            pageSize,
            filter,
            setCurrentPage: () => {},
            setPageSize: () => {},
            updateFilter: setFilter,
            reload: () => getAll(filter),
          }}
        >
          <PageToolbar
            leftElements={<SectionHeading>Podřízené organizace</SectionHeading>}
            rightElements={
              <Flex sx={{ gap: 4 }}>
                <Button
                  colorScheme="primary"
                  size="sm"
                  onClick={() =>
                    navigate(
                      `/organization/${organizationUnitId}/createDependent`,
                    )
                  }
                >
                  <Add />
                  Vytvořit podřízený subjekt
                </Button>
              </Flex>
            }
          />
          {effectivalyValid && <OrganizationListFilter hideShowAll />}
          <OrganizationsList
            organizations={data?.data.items ?? []}
            sx={{ boxShadow: 'card' }}
            columnsDefinition={[
              OrganizationListNameColumn,
              OrganizationListDescriptionColumn,
              OrganizationListCityColumn,
              { ...OrganizationListTypeColumn, cellProps: { px: 1 } },
              {
                ...OrganizationListValidColumn,
                cellExpr: (item) => (
                  <ValidityBadge valid={effectivalyValid && item.valid} />
                ),
                cellProps: { px: 1 },
              },
            ]}
          />
        </organizationListContext.Provider>
      </Box>
    )
  )
}
